// Shared between the /pandg landing page tiles and SearchPage's pandg pill
// strip, so the two stay in sync — one list of P&G PRO sub-ranges.
export const PANDG_CATEGORIES = [
  {
    key: 'dishwashing',
    label: 'Dishwashing',
    description: 'Fairy makes grease-cutting easy – manual and machine.',
    query: 'PGPRODW',
    adTitle: 'DISHWASHING',
    image: 'https://cdn.jjfoodservice.com/cms/dishwashing_0fdb7fcbd9.jpeg',
  },
  {
    key: 'degreasing',
    label: 'Degreasing',
    description: 'Deepio cuts tough grease, oil and grime fast.',
    query: 'PGPRODG',
    adTitle: 'DEGREASING',
    image: 'https://cdn.jjfoodservice.com/cms/degreasing_afc2544948.jpeg',
  },
  {
    key: 'floorCare',
    label: 'Floor Care',
    description: 'Flash cares for tile, vinyl, wood and stone.',
    query: 'PGPROFC',
    adTitle: 'FLOOR CARE',
    image: 'https://cdn.jjfoodservice.com/cms/floorcare_ef0644a3f6.jpeg',
  },
  {
    key: 'hardSurfaceCleaning',
    label: 'Hard Surface Cleaning',
    description: 'Milton and Flash make food-safe disinfecting easy.',
    query: 'PGPROHSC',
    adTitle: 'HARD SURFACE CLEANING',
    image: 'https://cdn.jjfoodservice.com/cms/hardsurface_ee3aa032cf.jpeg',
  },
  {
    key: 'concentratedSystemSolutions',
    label: 'Concentrated System Solutions',
    description: 'Concentrated dosing – less waste, lower cost',
    query: 'PGPROCSS',
    adTitle: 'CONCENTRATED SYSTEM SOLUTIONS',
    image: 'https://cdn.jjfoodservice.com/cms/system_a3dcfb63ad.jpeg',
  },
  {
    key: 'laundryDetergents',
    label: 'Laundry Detergents',
    description: 'Ariel, Bold and More – for linen and uniform care.',
    query: 'PGPROLD',
    adTitle: 'LAUNDRY DETERGENTS',
    image: 'https://cdn.jjfoodservice.com/cms/laundry_c4aa7ac7ff.jpeg',
  },
  {
    key: 'laundrySystemSolutions',
    label: 'Laundry System Solutions',
    description: 'Auto-dosing Ariel and Lenor for high-volume laundry',
    query: 'PGPROLSS',
    adTitle: 'LAUNDRY SYSTEM SOLUTIONS / AUTO -DOSE LAUNDRY',
    image: 'https://cdn.jjfoodservice.com/cms/solutions_4426b3b528.jpeg',
  },
];

export const PANDG_ALL_CATEGORY = {
  key: 'all',
  label: 'All P&G Pro',
  description: 'Browse the complete P&G PRO range',
  query: 'PGPRO',
  adTitle: 'P&G Pro Range',
};

export const PANDG_BANNER_IMAGE_URL =
  'https://cdn.jjfoodservice.com/cms/jjdelivery_L_b3b6e251f1.jpg';

export const PANDG_BROCHURE_URL =
  'https://cdn.jjfoodservice.com/cms/2026_08_Pn_G_Pro_ba2bde44ae.pdf';

export const PANDG_FAQ_ITEMS = [
  {
    question: 'Do I need a JJ account to order P&G PRO products?',
    answer:
      'JJ accounts are free, with no membership fees. Register to order online, through our app or with Telesales, or visit any JJ branch to order for collection without an account.',
  },
  {
    question: 'Is P&G PRO available for next-day delivery?',
    answer:
      'Most of our range is available for next-day delivery – orders placed before 5pm are assigned to your next available delivery day for your area, across the UK. Product availability may vary by branch for a small number of products. Collection from any JJ Foodservice branch is also available.',
  },
  {
    question: 'How does the Mix More Save More discount work?',
    answer:
      'Mix any 10 P&G PRO products, alongside any other eligible Mix & Save products, to unlock a discount – no need to buy 10 of the same items. Add 20+ mixed products for our best prices.',
  },
  {
    question: 'Is P&G PRO the same as professional cleaning chemicals?',
    answer: `Yes. P&G PRO is Procter & Gamble's professional range, so it covers the commercial cleaning chemicals that kitchens, hotels and care homes use every day. You'll recognise brands like Fairy, Flash and Ariel, but in commercial-grade formulas made for heavy, daily use.`,
  },
  {
    question:
      'Do you supply professional cleaning chemicals for restaurants, hotels and takeaways?',
    answer: `We do. As the official UK distributor of P&G PRO, we supply restaurants, hotels, takeaways, cafés, schools, care homes and caterers across the UK, with cleaning products delivered alongside your food and drink order.`,
  },
  {
    question: 'What types of cleaning chemicals can I buy from JJ?',
    answer: `The P&G PRO range covers dishwashing (Fairy), degreasing (Deepio), floor care (Flash), hard surface disinfecting (Milton and Flash), and laundry (Ariel, Bold and Lenor). Concentrated and auto-dosing systems are also available, giving you more cleans per pack, less waste and a lower cost per use.`,
  },
  {
    question: 'Can I order cleaning chemicals with my regular food order?',
    answer: `Yes. That's the point of buying from JJ. Your cleaning products arrive on the same delivery as your food, on one invoice, with no separate supplier to manage.`,
  },
  {
    question: `I'm not a business. Can I buy P&G PRO, and what's in it for me?`,
    answer: `Absolutely. Our P&G PRO range is open to home customers as well as businesses, and bulk buyers tend to love it. Commercial-grade formulas are built to work harder, so you get strong cleaning power and fewer re-washes. Concentrated products and larger packs mean each bottle goes further, which gives you a lower cost per use and fewer top-ups. Add any 10 eligible products to unlock our Mix More Save More discount, then get everything delivered with your food and drink order. That's one delivery and one invoice, and a well-stocked cupboard for the months ahead.`,
  },
];

export const PANDG_SWATCHES = [
  {$from: '#fdf3c7', $to: '#fff'},
  {$from: '#dceeff', $to: '#fff'},
  {$from: '#e5ddf5', $to: '#fff'},
  {$from: '#cfeee0', $to: '#fff'},
  {$from: '#d7ecff', $to: '#fff'},
  {$from: '#d7f2d0', $to: '#fff'},
  {$from: '#eee', $to: '#fff'},
];

// /halal landing page category tiles — each URL is a pre-built, already-
// encoded advanced search link (category ids, productFeatures=Halal and,
// for a couple of ranges, a plain q instead of category), supplied as-is
// rather than run through a URL builder so the encoding stays exactly as
// given. Every entry also carries `halal=true` (drives SearchPage's halal
// banner/pill strip — see isHalal there) and, for the ones with no `q` of
// their own, an explicit `q=*` so SearchPage's initial search actually runs
// rather than matching nothing.
export const HALAL_CATEGORIES = [
  {
    key: 'freshChicken',
    label: 'Halal Fresh Chicken',
    description:
      'Breast fillets, mini fillets, thigh meat, drumsticks and whole birds.',
    shopLabel: 'Shop fresh chicken',
    url:
      '/search?category=100019%2C200136%2C300164&productFeatures=Halal&sortType=category&adTitle=Halal%20Fresh%20Chicken&advanced=true&q=*&halal=true',
  },
  {
    key: 'frozenChicken',
    label: 'Halal Frozen Chicken',
    description:
      'Raw fillets, thighs and wings, plus breaded and battered lines.',
    shopLabel: 'Shop frozen chicken',
    url:
      '/search?category=100019%2C200136%2C300165&productFeatures=Halal&sortType=category&adTitle=Halal%20Frozen%20Chicken&advanced=true&q=*&halal=true',
  },
  {
    key: 'lambMutton',
    label: 'Halal Lamb & Mutton',
    description: 'Neck fillets, hind shanks, boneless leg and cutlet racks.',
    shopLabel: 'Shop lamb & mutton',
    url:
      '/search?category=100009%2C200248&productFeatures=Halal&adTitle=Halal%20Lamb%20%26%20Mutton&advanced=true&q=*&halal=true',
  },
  {
    key: 'beefBurgers',
    label: 'Halal Beef Burgers',
    description: 'Smash patties, quarter pounders and gourmet handmade-style.',
    shopLabel: 'Shop burgers',
    url:
      '/search?category=100029%2C200088%2C300068&productFeatures=Halal&sortType=category&adTitle=Halal%20Beef%20Burgers&advanced=true&q=*&halal=true',
  },
  {
    key: 'donerShawarma',
    label: 'Halal Doner & Shawarma',
    description:
      'Pre-cooked lamb, beef and chicken doner, spit cones and shawarma.',
    shopLabel: 'Shop doner & shawarma',
    url:
      '/search?category=100029%2C200089&productFeatures=Halal&sortType=category&adTitle=Halal%20Doner%20%26%20Shawarma&advanced=true&q=*&halal=true',
  },
  {
    key: 'beefSteak',
    label: 'Halal Beef & Steak',
    description: 'Topside, striploin, ribeye, brisket and minced beef.',
    shopLabel: 'Shop beef & steak',
    url:
      '/search?category=100009%2C200247&productFeatures=Halal&sortType=category&adTitle=Halal%20Beef%20%26%20Steak&advanced=true&q=*&halal=true',
  },
  {
    key: 'sausagesSaveloys',
    label: 'Halal Sausages & Saveloys',
    description:
      'Beef sausages, jumbo saveloys and hot dogs, skin-on and skinless.',
    shopLabel: 'Shop sausages',
    url:
      '/search?category=100029%2C200092&productFeatures=Halal&sortType=category&adTitle=Halal%20Sausages%20%26%20Saveloys&advanced=true&q=*&halal=true',
  },
  {
    key: 'pizzaToppings',
    label: 'Halal Pizza Toppings',
    description: 'Pepperoni, salami, cured ham and tandoori chicken dices.',
    shopLabel: 'Shop pizza toppings',
    url:
      '/search?category=100009%2C200130&productFeatures=Halal&sortType=category&adTitle=Halal%20Pepperoni%20%26%20Pizza%20Toppings&advanced=true&q=*&halal=true',
  },
  {
    key: 'turkeyDuck',
    label: 'Halal Turkey & Duck',
    description: 'Turkey rashers, smoked cooked turkey and roasted duck.',
    shopLabel: 'Shop turkey & duck',
    url:
      '/search?q=200236%7C%7C200138&productFeatures=Halal&adTitle=Halal%20Turkey%20%26%20Duck&advanced=true&halal=true',
  },
];

// No single ready-made "all halal" search link was supplied alongside the
// category ones above — this mirrors their own shape (productFeatures=Halal,
// advanced=true) with no category/q restriction, for the page's "view all"
// and hero/footer CTAs.
export const HALAL_ALL_URL =
  '/search?productFeatures=Halal&sortType=category&adTitle=Halal&advanced=true&halal=true';

// Same {label, url} shape as HALAL_CATEGORIES' entries so SearchPage's halal
// pill strip can treat it identically to a real category pill.
export const HALAL_ALL_CATEGORY = {
  key: 'all',
  label: 'All Halal',
  url: HALAL_ALL_URL,
};

export const HALAL_BANNER_IMAGE_URL =
  'https://cdn.jjfoodservice.com/cms/halal_Header_485f0e4b4e.jpg';

// /halal landing page "Halal Essentials" showcase — the same 6 example SKUs
// shown in the reference design (halal.html), now fetched live by item id
// (see getHalalBestSellers/halalBestSellers.saga.js, which searches with
// `first` — see search.api.js's own comment on that param) rather than
// hardcoding the reference design's illustrative prices.
export const HALAL_BEST_SELLER_ITEM_IDS = [
  'BUR098',
  'MEA237',
  'CHI438',
  'CHI306',
  'CHI389',
  'DON175',
];

export const HALAL_FAQ_ITEMS = [
  {
    question: 'Is it HMC halal?',
    answer:
      "We don't use HMC certification. Halal certification varies by product, and we can provide all the information, certification and logos on request.",
  },
  {
    question: 'Is it stunned first?',
    answer: 'Our products are non-HMC and are stunned first.',
  },
  {
    question: 'Can I request a halal certificate?',
    answer:
      "Yes. Simply email our Quality Assurance team at QualityAssurance@jjfoodservice.com, stating the specific products you need certificates for, and they'll get back to you.",
  },
  {
    question: 'How do I know if a product is halal?',
    answer:
      'All products in the sections above are halal. For peace of mind, look for "halal" in the product description and the halal logo, which is available to view on most packaging. If you\'re ever unsure, you can get in touch with our team.',
  },
  {
    question: 'Is all of the meat and poultry in this range halal?',
    answer:
      "Yes. Every product in our halal range — chicken, lamb, beef, burgers, doner, sausages and more — is sourced, prepared and supplied as certified halal. You won't need to check item by item; if it's listed here, it's halal.",
  },
  {
    question: 'What halal products does JJ Foodservice supply?',
    answer:
      'Our halal range covers fresh and frozen chicken, lamb and mutton, beef and steak cuts, beef burgers, doner and shawarma, sausages and saveloys, pizza toppings, and turkey and duck — over 250 lines in total, including our own JJ-branded ranges alongside leading suppliers.',
  },
  {
    question:
      'Do you supply halal meat for restaurants, takeaways and caterers?',
    answer:
      'We do. We supply halal chicken, lamb, beef and doner to restaurants, takeaways, kebab houses, caterers, cafés and care homes across the UK, with next-day delivery or collection from any of our branches.',
  },
  {
    question:
      "I'm not a business — can I still buy halal products in bulk, and what's in it for me?",
    answer:
      "Yes, our halal range is open to home customers as well as trade accounts. Buying in bulk means fewer trips to the shop — handy if you're hosting a party or gathering, or just want a freezer stocked with halal chicken, lamb and beef so you're not restocking every week. Everything is delivered to your door, so there's no carrying heavy packs home yourself. Some products are also marked \"Mix More, Save More\", meaning 10+ or 20+ of that specific line unlocks a lower price.",
  },
  {
    question: "What's the difference between halal doner and halal shawarma?",
    answer:
      "Both are pressed, seasoned meat cooked on a vertical spit, but they're seasoned differently: doner is typically a more lightly spiced lamb, beef or chicken mix associated with Turkish-style kebabs, while shawarma uses a bolder blend of Middle Eastern spices like cumin, cardamom and turmeric. We stock both, pre-cooked and cut, in chicken, lamb and beef.",
  },
  {
    question:
      'Is next-day delivery available on halal products, or can I collect in branch?',
    answer:
      'Yes to both. Halal orders are delivered next day across the UK, or you can collect from any of our branches if that suits your schedule better.',
  },
  {
    question: 'How is your halal meat certified?',
    answer:
      'All halal meat and poultry we supply is certified halal by an accredited Islamic certification body at the point of slaughter and processing. Certification standards and accrediting bodies vary by supplier and product type, so where it matters for your business, check the specific certification shown on the individual product page.',
  },
];
